import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import { fill } from '../../utils/contrastSvgAttributes';

export const useStyles = makeStyles(() => ({
  main: {
    position: 'relative',
    display: 'flex',
    height: 'calc(100vh - 120px)',
    width: '100%',
    backgroundColor: '#F7F7FA',
  },
  container: {
    position: 'relative',
    top: '0px',
    left: '0',
    display: 'flex',
    justifyContent: 'flex-end',
    height: 'auto',
    width: '100%',
    backgroundColor: '#EBECF4',
    overflow: 'auto',
  },
  cardContainer: {
    position: 'absolute',
    top: '5px',
    left: '20px',
    width: 'calc(100% - 40px)',
    height: 'calc(100% - 20px)',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    zIndex: 2,
  },
  cardPreview: {
    position: 'relative',
    top: '55px',
    height: 'calc(100% - 60px)',
    backgroundColor: 'rgba(219, 220, 229, 0.28)',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: '0.5s ease-in-out',
    overflow: 'auto',
    '@media (max-width: 1200px)': {
      width: '150px',
    },
    '@media (max-width: 780px)': {
      width: '100px',
    },
    '@media (max-width: 980px)': {
      top: '100px',
      height: 'calc(100% - 105px)'
    },
  },
  cardPreviewFullWidth: {
    width: 'calc(100%)'
  },
  cardPreviewDefaultWidth: {
    width: 'calc(100% - 310px)',
    '@media (max-width: 1200px)': {
      width: 'calc(100% - 250px)',
    },
    '@media (max-width: 980px)': {
      width: 'calc(100% - 212px)',
    },
    '@media (max-width: 780px)': {
      width: 'calc(100% - 200px)',
    },
  },
  cardHeader: {
    position: 'absolute',
    left: '1px',
    top: '10px',
    height: '45px',
    width: 'calc(100% - 2px)',
    backgroundColor: '#FFFFFF',
    borderBottom: 'solid 1px rgba(44, 45, 62, 0.3)',
    alignItems: 'center',
    zIndex: 3,
    transition: '0.5s ease-in-out',
    '@media (max-width: 980px)': {
      height: '90px',
    },
  },
  cardHeaderFullWidth: {
    left: 'calc(100% - 480px)',
  },
  cardHeaderDefaultWidth: {
    left: 'calc(100% - 760px)',
    '@media (max-width: 1200px)': {
      left: 'calc(100% - 710px)',
    },
    '@media (max-width: 980px)': {
      left: 'calc(100% - 510px)',
    },
    '@media (max-width: 780px)': {
      left: 'calc(100% - 460px)',
    },
  },
  cardHeaderText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
    marginLeft: '20px',
    marginTop: '8px',
  },
  backButton: {
    color: '#2C2D3E',
    position: 'relative',
    width: '30px',
    height: '30px',
    background: '#FFFFFF',
    marginLeft: '11px',
    border: '1px solid #2C2D3E',
    borderColor: '#2C2D3E',
    borderRadius: '3px',
    fontSize: 'small',
    '&:hover': {
      cursor: 'pointer',
      background: '#CACAFC80',
    },
  },
  arrowInBackButton: {
    color: '#2C2D3E',
    marginTop: '3px',
    marginLeft: '3px',
  },
  cardSidebar: {
    position: 'absolute',
    left: 'calc(100% - 310px)',
    top: '1px',
    height: 'calc(100% - 2px)',
    width: '307px',
    backgroundColor: '#FFFFFF',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: 3,
    transition: '0.5s ease-in-out',
    '@media (max-width: 1200px)': {
      width: '250px',
      left: 'calc(100% - 253px)'
    },
    '@media (max-width: 1000px)': {
      width: '210px',
      left: 'calc(100% - 213px)'
    },
    '@media (max-width: 768px)': {
      width: '180px',
      left: 'calc(100% - 183px)'
    },
  },
  card: {
    position: 'relative',
    display: 'flex',
    outline: 'solid 2px rgba(44, 45, 62, 0.3)',
    outlineRadius: '4px',
  },
  cardThumbnails: {
    position: 'absolute',
    left: 'calc(100% - 290px)',
    top: '100px',
    maxHeight: 'calc(100% - 101px)',
    width: '290px',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'auto',
    zIndex: 3,
    transition: '0.5s ease-in-out',
    '@media (max-width: 1200px)': {
      width: '220px',
      left: 'calc(100% - 225px)'
    },
    '@media (max-width: 1000px)': {
      width: '210px',
      left: 'calc(100% - 210px)'
    },
    '@media (max-width: 768px)': {
      width: '150px',
      left: 'calc(100% - 155px)'
    },
  },
  cardSidebarMenu: {
    width: '270px',
    padding: '60px 20px 10px 15px',
    transition: '0.5s ease-in-out',
    '@media (max-width: 1200px)': {
      width: '240px',
    },
    '@media (max-width: 1000px)': {
      width: '200px',
    },
    '@media (max-width: 768px)': {
      width: '170px',
    },
  },
  cardPreviewMenu: {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    top: '-5px',
    height: '45px',
    zIndex: 50,
    transition: '0.5s ease-in-out',
    '@media (max-width: 980px)': {
      width: '300px',
      flexWrap: 'wrap'
    },
  },
  cardPreviewMenuIcon: {
    width: '22px',
    height: '22px',
    margin: '12px 10px',
    cursor: 'pointer',
  },
  cardPreviewMenuIconDisabled: {
    pathFill: '#757575',
    cursor: 'not-allowed',
    pointerEvents: 'all',
  },
  pipe: {
    margin: '6px 10px',
  },
  switchIcon: {
    position: 'relative',
    top: '1px',
    width: '20px',
    height: '20px',
    padding: '5px',
    color: '#3C419A',
    zIndex: 10,
    transition: '0.5s ease-in-out',
    cursor: 'pointer',
    '& path': {
      fill: fill,
    },
  },
  switchIconButton: {
    position: 'absolute',
    top: '12px',
    width: '32px',
    height: '32px',
    borderRadius: '100%',
    zIndex: 10,
    '&:hover': {
      backgroundColor: '#DADAFD',
      borderRadius: '100%',
    },
  },
  switchIconButtonFullWidth: {
    left: 'calc(100% - 50px)',
    transition: '0.5s ease-in-out',
    '@media (max-width: 1200px)': {
      left: 'calc(100% - 50px)',
    },
  },
  switchIconButtonDefaultWidth: {
    left: 'calc(100% - 300px)',
    transition: '0.5s ease-in-out',
    '@media (max-width: 1200px)': {
      left: 'calc(100% - 250px)',
    },
    '@media (max-width: 1000px)': {
      left: 'calc(100% - 220px)',
    },
    '@media (max-width: 768px)': {
      left: 'calc(100% - 183px)'
    },
  },
  cardDetails: {
    position: 'absolute',
    left: 'calc(100% - 290px)',
    top: '100px',
    width: '285px',
    backgroundColor: '#FFFFFF',
    listStyle: 'none',
    margin: '0px',
    padding: '0px',
    transition: '0.5s ease-in-out',
    '& li': {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '13px',
      zIndex: 3,
      color: '#000000',
      padding: '8px',
      '& span': {
        '@media (max-width: 1200px)': {
          marginTop: '16px',
          left: '14px',
        },
      },
      '@media (max-width: 1200px)': {
        paddingBottom: '10px',
      },
    },
    '@media (max-width: 1200px)': {
      width: 'calc(100% - 10px)',
      left: 'calc(100% - 240px)'
    },
    '@media (max-width: 1000px)': {
      width: 'calc(100% - 10px)',
      left: 'calc(100% - 200px)'
    },
    '@media (max-width: 780px)': {
      width: 'calc(100%)',
      left: 'calc(100% - 180px)'
    },
    '@media (max-height: 565px)': {
      maxHeight: 'calc(100% - 180px)',
      overflowY: 'auto'
    }
  },
  cardDetail: {
    position: 'absolute',
    left: '130px',
    fontWeight: 700,
    maxWidth: '140px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  //todo: I know this absolute positioning is ugly, but in current way it is displayed, I had to do it the same ugly way :(
  buttonsContainer: {
    margin: '0px -5px',
    width: '100%',
    backgroundColor: 'yellow',
    position: 'absolute',
    height: '100%',
  },
  saveButton: {
    position: 'absolute',
    right: '60px',
    top: '-5px',
    zIndex: 3,
    width: '160px',
  },
  editDetailsButton: {
    position: 'absolute',
    right: '10px',
    bottom: '15px',
  },
  paddedContainer: {
    padding: '20px',
  },
  breadcrumbsResponsive: {
    '@media (max-width: 900px)': {
      maxWidth: '350px'
    }
  }
}));

export const ZoomInput = withStyles((theme) => ({
  root: {
    position: 'relative',
    left: '15x',
    top: '6px',

    'label + &': {
      marginTop: theme.spacing(3),
    },

    '& .MuiSelect-icon': {
      width: '20px',
      height: '20px',
      top: '7px',
    },
  },
  input: {
    width: '40px',
    height: '20px',
    borderRadius: 3,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #ced4da',
    fontSize: 14,
    padding: '6px 20px 3px 5px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: 'Roboto',
    '&:focus': {
      border: '2px solid #ced4da',
      borderRadius: 3,
    },
  },
}))(InputBase);

export const getToggleButtonStyle = (isSelected: boolean, small?: boolean) => {
  return {
    color: isSelected ? '#3C419A' : '#2C2D3E',
    backgroundColor: isSelected ? '#D6D6FB' : '#FFFFFF',
    fontSize: '12px',
    fontWeight: isSelected ? 500 : 400,
    padding: small ? '5px' : '7px',
  };
};
